import { tooltipClasses } from '@mui/material/Tooltip';
import { Tooltip, TooltipProps, styled as styledMui } from '@mui/material';

const StyledTooltip = styledMui(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}));

export default StyledTooltip;
